<template>
	<div class="lists columns">
		<div class="column selection-list" style="flex: 2">
			<SelectionListHeader
				:title="title"
				:tab="tab"
				:mode="'selected'"
				@search="search"
			/>
			<div class="list-container">
				<div
					class="panel-list narrow no-hover"
					v-for="(item) in fromItems"
					:key="item[fromIdName]"
				>
					<p class="panel-list-item" style="flex:2"> {{ item[fromDisplayName] }} </p>
					<div class="panel-list-item" style="flex:3; display: flex; flex-direction: row; align-items: right; justify-content: flex-end; width:100%">
						<div style="margin-right: 1rem;">
							<div class="control item-dropdown" style="max-width:120px">
								<v-select
									class="panel-select header"
									v-model="item.selectedOption"
									:options="selectionOptions"
									:allowEmpty="false"
									:internalSearch="false"
									:showLabels="false"
									:searchable="false"
									:open-direction="'top'"
									@select="(event) => selectedItemOption(item, event)"
									track-by="value"
									label="name"
								>
									<span slot="noResult">{{ $t('mapping_selection.no_results') }}</span>
									<span
										slot="caret"
										slot-scope="{ toggle }"
										class="caret"
										@mousedown.prevent.stop="toggle()"
									><i class="fas fa-caret-down caret-inner" /></span>
								</v-select>
							</div>
						</div>

						<div style="margin-right: 1rem;">
							<div style="display: flex;" v-if="item.selectedOption?.value == 2">
								<span>{{ $t('mapping_selection.with') }}</span>
								
								<div class="control item-dropdown" style="margin: 0 1rem;">
									<v-select
										class="panel-select header"
										v-model="item.selectedTarget"
										:options="toItems"
										:allowEmpty="false"
										:internalSearch="false"
										:showLabels="false"
										:searchable="false"
										:open-direction="'top'"
										@select="(event) => selectReplacementOption(item, event)"
										track-by="id"
										label="name"
									>
										<span slot="noResult">{{ $t('mapping_selection.no_results') }}</span>
										<span
											slot="caret"
											slot-scope="{ toggle }"
											class="caret"
											@mousedown.prevent.stop="toggle()"
										><i class="fas fa-caret-down caret-inner" /></span>
									</v-select>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="panel-list narrow no-hover" v-if="fromItems.length == 0">
					<p class="header-item">
						Inga resultat
					</p>
				</div>
			</div>
            
		</div>
		<div class="column">
			<div class="subtitle"> {{ targetTypeTitle }} {{ $t('mapping_selection.at') }} {{ targetCustomerName }}</div>
			<div style="overflow:auto">
				<div
					class="panel-list narrow no-hover"
					v-for="(item) in toItems"
					:key="item[toIdName]"
				>
					<p class="panel-list-item"> {{ item[toDisplayName] }} </p>
				</div>
				<div class="panel-list narrow no-hover" v-if="toItems.length == 0">
					<p class="header-item">
						Inga resultat
					</p>
				</div>
			</div>
            
		</div>
	</div>
	
</template>

<script>
import SelectionListHeader from '@/components/SelectionList/SelectionListHeader.vue';

export default {
	components: { SelectionListHeader },
	props: {
		fromItems: Array,
		toItems: Array,
		title: String,
		tab: Number,
		blankSelection: String,
		subListName: String,
		targetCustomerName: String,
		targetTypeTitle: String,
		fromIdName: String,
		toIdName: String,
		fromDisplayName: {
			type: String,
			default: 'name'
		},
		toDisplayName: {
			type: String,
			default: 'name'
		},
		selectionOptions: Array
	},
	data() {
		return {
			searchValue: ''
		};
	},
	watch: {
		fromItems: {
			handler: function() {
				this.mapItemValuesToDropdownOptions();
			}
		},
		toItems: {
			handler: function() {
				this.mapItemValuesToDropdownOptions();
			}
		}
	},
	methods: {
		selectItem(item, index) {
			this.$emit('selectItem', item, index);
		},
		search(searchValue) {
			this.searchValue = searchValue;
			this.$emit('search', searchValue);
		},
		selectedItemOption(item, option) {
			this.$emit('selectedItemOption', item, option.value);
			
			if (option.value === this.selectionOptions[2]?.value) {
				item.selectedTarget = this.toItems[0];
				this.selectReplacementOption(item, this.toItems[0]);
			}
		},
		selectReplacementOption(item, option) {
			this.$emit('selectedReplacementOption', item, option.id);

		},
		mapItemValuesToDropdownOptions() {
			this.fromItems.map(item => {
				if (!item.selectedOption) {
					item.selectedOption = this.selectionOptions.find(option => option.value == item.moveType);
				}
				
				if (!item.selectedTarget && item.moveType === 2 && this.toItems.length) {
					item.selectedTarget = this.toItems.find(option => option.id == item.idToReplace);
				}
				
				return item;
			});
		}
	},
	created() {
		this.mapItemValuesToDropdownOptions();
	}
};
</script>

<style lang="scss" scoped>

.subtitle {
  min-width: 130px;
  padding-top: 10px;
  margin-bottom: 0.5rem !important;
  font-weight: 600;
}

.selection-list {
	overflow: auto;
}

.panel-list {
    display: flex;
}
</style>
